import * as React from "react"
import Svg, { Circle, Path, Defs, LinearGradient, Stop } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={69}
      height={66}
      viewBox="0 0 69 66"
      fill="none"
    >
      <Circle cx={33} cy={33} r={33} fill="url(#paint0_linear_2063_2962)" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.704 7.711a3 3 0 01.002 4.243L34.622 44.069a3 3 0 01-4.243.001l-9.625-9.625a3 3 0 114.242-4.242l7.503 7.502L62.46 7.713a3 3 0 014.243-.002z"
        fill="url(#paint1_linear_2063_2962)"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_2063_2962"
          x1={33}
          y1={0}
          x2={33}
          y2={66}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#0059D4" />
          <Stop offset={0.265625} stopColor="#004EBA" />
          <Stop offset={0.9999} stopColor="#013174" />
          <Stop offset={1} stopColor="#0059D4" stopOpacity={0} />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_2063_2962"
          x1={60.7571}
          y1={17.0016}
          x2={31.3825}
          y2={40.9421}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#0059D4" />
          <Stop offset={0.526042} stopColor="#1E05BA" />
          <Stop offset={0.9999} stopColor="#0059D4" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default SvgComponent
